import { UiTheme } from '@core/api/tenant/tenant.models';

export const MOCK_THEME: UiTheme = {
  version: 1,
  headerMode: 'blur',
  expandedLogo: {
    src: '/images/logo-expanded-v2.svg',
    width: 205,
    height: 62,
  },
  collapsedLogo: {
    src: '/images/logo-collapsed-v2.svg',
    width: 62,
    height: 62,
  },
  colors: {
    customBaseLoad: '#C530DE',
    customBorderMuted: '#DADAE7',
    customAssetOverviewPocCircle: '#C8D6DD',
    customAssetOverviewDotFill: '#82FCA8',
    customSecondaryBorder: '#B7CFDF',
    customSuccess: '#58FF85',
    customError: '#FF0101',
    customReady: '#33AF92',
    customCharging: '#58A5DB',
    customQueued: '#F79F00',
    customFaulted: '#FF9999',
    customTimelineScrollbarTrack: '#d5dbdf',
    customDisabledInputBackground: '#f0f0f0',
    customDisabledInputColor: '#6c757d',
    customDisabledCard: '#D1D8E0',
    customDisabledCardText: '#9DACBD',
    customNetProfit: '#B2E1D6',
    customNetProfitDisabled: '#D7DFE5',
    customFlexDrillDownDateHighlight: '#7CAFD1BD',
    customTradingTableEditedCell: '#FFF4C2',
    customTradingTableSelectedOverlay: '#A7B8C333',
    sessionOutcomeCompleted: '#009B77',
    sessionOutcomeShort: '#FFD600',
    sessionOutcomeIncomplete: '#FF7A00',
    sessionOutcomeShortAndIncomplete: '#87620B',
    sessionOutcomeFaulted: '#FF0000',
    sessionOutcomeShortAndFaulted: '#56040A',

    backgroundMain: '#E2EAEF',
    backgroundFixed: '#FFFFFF',
    backgroundMoveable: '#E8EEF2',
    backgroundMenu: '#FFFFFF',
    backgroundPanel: '#F1F5F8',
    backgroundContainerPrimary: '#FFFFFF',
    backgroundContainerSecondary: '#E2EAEF',
    backgroundContainerInverse: '#000000',
    backgroundContainerTertiary: '#F1F5F8',
    backgroundBorder: '#FFFFFF',

    foregroundPrimary: '#000000',
    foregroundSecondary: '#FFFFFF',
    actionPrimary: '#009B77',
    actionPrimaryText: '#0A734F',
    actionSecondary: '#021CF5',
    actionSecondaryText: '#005197',

    chargingStatusForeground: '#FFFFFF',
    chargingStatusReady: '#009B77',
    chargingStatusCharging: '#021CF5',
    chargingStatusQueued: '#FFA400',
    chargingStatusFaulted: '#FF0000',
    chargingStatusInDepot: '#687985',
    chargingStatusOnRoad: '#A768B2',
    chargingStatusUnknown: '#000000',

    chartEv: '#0277C8',
    chartDepotLoad: '#A768B2',
    chartPvSolar: '#FFD600',
    chartGrid: '#000000',
    chartBattery: '#82E9A2',
    chartPhysicalNotification: '#7C3AED',
    chartGrossRevenue: '#710FA2',
    chartNetRevenue: '#ED32F7',

    headerTitle: '#FFFFFF',
    headerBreadcrumbCurrent: '#FFFFFF',
    headerTabText: '#FFFFFF',
    headerTabLine: '#FFFFFF',
    headerActionItemBg: '#FFFFFF',
    headerActionItemFg: '#000000',

    statusSuccess: '#009B77',
    statusSuccessText: '#006945',
    statusError: '#FF0000',
    statusErrorText: '#CD0000',
    statusWarning: '#FF7A00',
    statusWarningText: '#D56B0A',
    statusInfo: '#239FD0',
    statusInfoText: '#0076B3',
    statusIdle: '#11614C',
    statusOffline: '#919191',
    statusOfflineText: '#535353',

    riskBandLow: '#009B77',
    riskBandModerate: '#FF7A00',
    riskBandHigh: '#FF0000',
    riskBandNotEnoughData: '#919191',
    riskBandNotOperational: '#000000',

    strokePrimary: '#000000',
    strokeCardBorder: '#00000000',
    strokeContainer: '#00000000',
    strokeAction: '#000000',
  },
  borderRadiuses: {
    cards: '24px',
    menu: '16px',
    container: '12px',
    containerSecondary: '8px',
    cta: '12px',
    circle: '9999px',
    primary: '16px',
    secondary: '8px',
    tertiary: '4px',
  },
  filters: {
    customCardMoveable: 'drop-shadow(0 -12px 28px rgba(255, 255, 255, .45)) drop-shadow(0 12px 36px rgba(38, 73, 96, .45))',
  },
  dropShadows: {
    customBaseLoad: '0 0 10px rgba(197, 48, 222, 0.41)',
    customCardFixed: '0 12px 28px #2649601f',
    dropdown: '0 12px 36px rgba(0, 0, 0, 0.32)',
  },
};

export const MOCK_DARK_THEME: UiTheme = {
  version: 1,
  headerMode: 'blur',
  expandedLogo: {
    src: '/images/logo-expanded-v2.svg',
    width: 205,
    height: 62,
  },
  collapsedLogo: {
    src: '/images/logo-collapsed-v2.svg',
    width: 62,
    height: 62,
  },
  colors: {
    customBaseLoad: '#C530DE',
    customBorderMuted: '#191B1C',
    customAssetOverviewPocCircle: '#C8D6DD',
    customAssetOverviewDotFill: '#82FCA8',
    customSecondaryBorder: '#B7CFDF',
    customSuccess: '#58FF85',
    customError: '#FF0101',
    customReady: '#33AF92',
    customCharging: '#58A5DB',
    customQueued: '#F79F00',
    customFaulted: '#FF9999',
    customTimelineScrollbarTrack: '#d5dbdf',
    customDisabledInputBackground: '#191B1C',
    customDisabledInputColor: '#6c757d',
    customDisabledCard: '#D1D8E0',
    customDisabledCardText: '#9DACBD',
    customNetProfit: '#B2E1D6',
    customNetProfitDisabled: '#D7DFE5',
    customFlexDrillDownDateHighlight: '#7CAFD1BD',
    customTradingTableEditedCell: '#FFF4C2',
    customTradingTableSelectedOverlay: '#A7B8C333',
    sessionOutcomeCompleted: '#009B77',
    sessionOutcomeShort: '#FFD600',
    sessionOutcomeIncomplete: '#FF7A00',
    sessionOutcomeShortAndIncomplete: '#87620B',
    sessionOutcomeFaulted: '#FF0000',
    sessionOutcomeShortAndFaulted: '#56040A',

    backgroundMain: '#191B1C',
    backgroundFixed: '#262C2F',
    backgroundMoveable: '#191B1C',
    backgroundMenu: '#191B1C',
    backgroundPanel: '#2F3538',
    backgroundContainerPrimary: '#2F3538',
    backgroundContainerSecondary: '#191B1C',
    backgroundContainerInverse: '#000000',
    backgroundContainerTertiary: '#2F3538',
    backgroundBorder: '#000000',

    foregroundPrimary: '#FFFFFF',
    foregroundSecondary: '#000000',
    actionPrimary: '#009B77',
    actionPrimaryText: '#009B77',
    actionSecondary: '#021CF5',
    actionSecondaryText: '#005197',

    chargingStatusForeground: '#FFFFFF',
    chargingStatusReady: '#009B77',
    chargingStatusCharging: '#0277C8',
    chargingStatusQueued: '#FFA400',
    chargingStatusFaulted: '#FF0000',
    chargingStatusInDepot: '#52636F',
    chargingStatusOnRoad: '#A768B2',
    chargingStatusUnknown: '#FFFFFF',

    chartEv: '#0277C8',
    chartDepotLoad: '#A768B2',
    chartPvSolar: '#FFD600',
    chartGrid: '#000000',
    chartBattery: '#82E9A2',
    chartPhysicalNotification: '#E9D5FF',
    chartGrossRevenue: '#710FA2',
    chartNetRevenue: '#ED32F7',

    headerTitle: '#FFFFFF',
    headerBreadcrumbCurrent: '#FFFFFF',
    headerTabText: '#FFFFFF',
    headerTabLine: '#FFFFFF',
    headerActionItemBg: '#000000',
    headerActionItemFg: '#FFFFFF',

    statusSuccess: '#009B77',
    statusSuccessText: '#006945',
    statusError: '#FF0000',
    statusErrorText: '#CD0000',
    statusWarning: '#FF7A00',
    statusWarningText: '#D56B0A',
    statusInfo: '#239FD0',
    statusInfoText: '#0076B3',
    statusIdle: '#11614C',
    statusOffline: '#919191',
    statusOfflineText: '#535353',

    riskBandLow: '#009B77',
    riskBandModerate: '#FF7A00',
    riskBandHigh: '#FF0000',
    riskBandNotEnoughData: '#919191',
    riskBandNotOperational: '#FFFFFF',

    strokePrimary: '#FFFFFF',
    strokeCardBorder: '#00000000',
    strokeContainer: '#00000000',
    strokeAction: '#000000',
  },
  borderRadiuses: {
    cards: '24px',
    menu: '16px',
    container: '12px',
    containerSecondary: '8px',
    cta: '12px',
    circle: '9999px',
    primary: '16px',
    secondary: '8px',
    tertiary: '4px',
  },
  filters: {
    customCardMoveable: 'drop-shadow(0 -12px 28px rgba(0, 0, 0, .15)) drop-shadow(0 12px 36px rgba(0, 0, 0, .25))',
  },
  dropShadows: {
    customBaseLoad: '0 0 10px rgba(197, 48, 222, 0.41)',
    customCardFixed: '0 12px 28px #2649601f',
    dropdown: '0 12px 36px rgba(0, 0, 0, 0.32)',
  },
};
